import { X, Play } from 'lucide-react';

export type MediaType = 'image' | 'gif' | 'video';

interface MediaPreviewProps {
  url: string;
  type: MediaType;
  onRemove: () => void;
  className?: string;
}

export const MediaPreview = ({ url, type, onRemove, className = '' }: MediaPreviewProps) => {
  return (
    <div className={`relative rounded-xl overflow-hidden bg-[#1F1010] ${className}`}>
      {type === 'video' ? (
        <div className="relative aspect-video">
          <video
            src={url}
            className="w-full h-full object-cover"
            preload="metadata"
            muted
          />
          <div className="absolute inset-0 flex items-center justify-center bg-black/20">
            <div className="w-10 h-10 rounded-full bg-sossiety-red flex items-center justify-center">
              <Play className="w-5 h-5 text-white fill-white ml-0.5" />
            </div>
          </div>
        </div>
      ) : (
        <img
          src={url}
          alt="Post media"
          className="w-full object-cover max-h-72"
        />
      )}
      <button
        onClick={onRemove}
        className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/70 flex items-center justify-center hover:bg-black/90 transition-colors"
        aria-label="Remove media"
      >
        <X className="w-4 h-4 text-white" />
      </button>
    </div>
  );
};
